export interface ICompany {
  name: string;
  logo: string;
  phone: string;
  email: string;
  website: string;
}

export interface IPin {
  id: string;
  label: string;
  labelDirection: "left" | "right";
  active: boolean;
  companies: ICompany[];
}

export const pins: IPin[] = [
  {
    id: "1",
    label: "Bergen",
    labelDirection: "right",
    active: false,
    companies: [
      {
        name: "Service Elektrikern AS",
        logo: "https://res.cloudinary.com/rubics/image/upload/v1727769055/66fba9def2f74c7a32463783-SE-logo.jpg",
        phone: "552 10 570",
        email: "firmapost@se-el.no",
        website: "se-el.no",
      },
      {
        name: "Kvassheim Elektro",
        logo: "https://cdn.rubics.as/elteragruppen/69662b37139749ea375d2077/logo-kvassheim.png",
        phone: "559 82 080",
        email: "post@kvassheim-elektro.no",
        website: "www.kvassheim-elektro.no",
      },
    ],
  },
  {
    id: "2",
    label: "Sandnes",
    labelDirection: "right",
    active: false,
    companies: [
      {
        name: "Kreatel AS",
        logo: "https://cdn.rubics.as/kreatel/65802dac1cebaadcd9b1f62c/kreatel-logo.webp",
        phone: "916 93 000",
        email: "post@kreatel.no",
        website: "kreatel.no",
      },
    ],
  },
  {
    id: "3",
    label: "Valdres",
    labelDirection: "left",
    active: false,
    companies: [
      {
        name: "Valdres Installasjon AS",
        logo: "https://res.cloudinary.com/rubics/image/upload/h_250/f_auto/cwosu3y6swr7kr5tual9.png",
        phone: "612 51 760",
        email: "post@valdres-installasjon.no",
        website: "valdres-installasjon.no",
      },
    ],
  },
  {
    id: "4",
    label: "Lillehammer",
    labelDirection: "left",
    active: false,
    companies: [
      {
        name: "Eltera Lillehammer",
        logo: "https://res.cloudinary.com/rubics/image/upload/h_250/f_auto/ir20anbqz3eeyju74ye3.png",
        phone: "612 51 760",
        email: "post.lillehammer@eltera.no",
        website: "eltera.no/kontakt",
      },
      {
        name: "Østbye & Sletmoen AS",
        logo: "https://res.cloudinary.com/rubics/image/upload/h_250/f_auto/asxehrntanxybtkcb3iy.png",
        phone: "612 46 710",
        email: "post@oogs.no",
        website: "oogs.no",
      },
    ],
  },
  {
    id: "5",
    label: "Gjøvik",
    labelDirection: "left",
    active: false,
    companies: [
      {
        name: "Eltera Gjøvik",
        logo: "https://res.cloudinary.com/rubics/image/upload/h_250/f_auto/qatesps43rss7vbqrez2.png",
        phone: "611 40 900",
        email: "post.gjovik@eltera.no",
        website: "eltera.no/kontakt",
      },
    ],
  },
  {
    id: "6",
    label: "Skreia",
    labelDirection: "left",
    active: false,
    companies: [
      {
        name: "Hveem Elektro AS",
        logo: "https://res.cloudinary.com/rubics/image/upload/h_250/f_auto/655b54273576521c956907bc-Hveem_logo_liten.png",
        phone: "611 66 590",
        email: "post@hveemelektro.no",
        website: "hveemelektro.no",
      },
    ],
  },
  {
    id: "7",
    label: "Skedsmokorset",
    labelDirection: "right",
    active: false,
    companies: [
      {
        name: "Seko Elektro AS",
        logo: "https://res.cloudinary.com/rubics/image/upload/h_250/f_auto/bkv6cnpuimvrcwngxq1j.png",
        phone: "638 79 600",
        email: "kontakt@seko.no",
        website: "seko.no",
      },
    ],
  },
  {
    id: "8",
    label: "Porsgrunn",
    labelDirection: "right",
    active: false,
    companies: [
      {
        name: "Eltera Skagerrak",
        logo: "https://res.cloudinary.com/rubics/image/upload/h_250/f_auto/ng3nmzesmeynpv7ydzec.png",
        phone: "905 40 100",
        email: "post.skagerrak@eltera.no",
        website: "eltera.no/kontakt",
      },
    ],
  },
  {
    id: "9",
    label: "Elverum",
    labelDirection: "right",
    active: false,
    companies: [
      {
        name: "Eltera Elverum",
        logo: "https://res.cloudinary.com/rubics/image/upload/h_250/f_auto/vlpnyjrbcec3wdr44jyj.png",
        phone: "418 40 100",
        email: "post.elverum@eltera.no",
        website: "eltera.no/kontakt",
      },
    ],
  },
  {
    id: "10",
    label: "Ringsaker",
    labelDirection: "left",
    active: false,
    companies: [
      {
        name: "Eltera Ringsaker",
        logo: "https://res.cloudinary.com/rubics/image/upload/h_250/f_auto/buwt7efhdfhndlvwjhpi.png",
        phone: "902 40 100",
        email: "post.ringsaker@eltera.no",
        website: "eltera.no/kontakt",
      },
    ],
  },
  {
    id: "11",
    label: "Plassen",
    labelDirection: "right",
    active: false,
    companies: [
      {
        name: "Eltera Plassen",
        logo: "https://res.cloudinary.com/rubics/image/upload/h_250/f_auto/ooifzgzlnwnmhvssgkkd.png",
        phone: "623 52 684",
        email: "post.plassen@eltera.no",
        website: "eltera.no/kontakt",
      },
    ],
  },
  {
    id: "12",
    label: "Lørenskog",
    labelDirection: "right",
    active: false,
    companies: [
      {
        name: "Memo Elektro AS",
        logo: "https://res.cloudinary.com/rubics/image/upload/h_250/f_auto/vehwpnkglv4vn7cvbprj.png",
        phone: "679 19 444",
        email: "post@memoelektro.no",
        website: "memoelektro.no",
      },
    ],
  },
  {
    id: "13",
    label: "Oslo",
    labelDirection: "left",
    active: false,
    companies: [
      {
        name: "Eltera Oslo",
        logo: "https://cdn.rubics.as/elteragruppen/696627c4139749ea375ce4ca/logo-eltera-oslo.png",
        phone: "901 40 100",
        email: "post@eltera.no",
        website: "eltera.no/kontakt/oslo",
      },
      {
        name: "Arkel Asker & Bærum",
        logo: "https://cdn.rubics.as/elteragruppen/696627d7139749ea375ce548/logo-arkel.png",
        phone: "669 82 442",
        email: "ab@arkel.no",
        website: "asker.arkel.no",
      },
      {
        name: "BE Elektro",
        logo: "https://cdn.rubics.as/elteragruppen/69c652aac91ea0a4ebdeacff/be-logo.jpg",
        phone: "230 31 940",
        email: "be-elektro@be-elektro.no",
        website: "",
      },
    ],
  },
  {
    id: "14",
    label: "Moss",
    labelDirection: "right",
    active: false,
    companies: [
      {
        name: "Team Installasjon AS",
        logo: "https://res.cloudinary.com/rubics/image/upload/h_250/f_auto/zeve3epfju31cb3mnaol.png",
        phone: "222 36 390",
        email: "post@teaminstallasjon.no",
        website: "teaminstallasjon.no",
      },
    ],
  },
  {
    id: "15",
    label: "Nannestad",
    labelDirection: "right",
    active: false,
    companies: [
      {
        name: "Nordengen AS",
        logo: "https://cdn.rubics.as/nordengen/65c4d9cc1c7282611de6b643/h_100/Nordengen_RGB_Positiv_Uten%20ElteraGruppen.png",
        phone: "639 99 950",
        email: "firmapost@nordengen.no",
        website: "nordengen.no",
      },
    ],
  },
  {
    id: "16",
    label: "Overhalla",
    labelDirection: "right",
    active: false,
    companies: [
      {
        name: "Amdal Elektro",
        logo: "https://res.cloudinary.com/rubics/image/upload/v1725541472/66d9ac5f569a2f1c0a7eb92f-Amdal_Elektro_Logo_Positiv_H%C3%B8yre%20%282%29.png",
        phone: "742 81 119",
        email: "post@amdalelektro.no",
        website: "amdalelektro.no",
      },
    ],
  },
  {
    id: "17",
    label: "Bryne",
    labelDirection: "left",
    active: false,
    companies: [
      {
        name: "El-Team",
        logo: "https://res.cloudinary.com/rubics/image/upload/v1725541575/66d9acc6569a2f1c0a7ebf62-El-team_Logo_Positiv_Midt%20%281%29.png",
        phone: "514 86 740",
        email: "firmapost@el-team.net",
        website: "el-team.net",
      },
    ],
  },
  {
    id: "18",
    label: "Egersund",
    labelDirection: "right",
    active: false,
    companies: [
      {
        name: "El-experten",
        logo: "https://cdn.rubics.as/el-experten-as/66f3bdf4637bc84fecddb4d6/hovedlogeo-elexperten.png",
        phone: "514 96 000",
        email: "post@el-experten.no",
        website: "el-experten.no/",
      },
    ],
  },
  {
    id: "19",
    label: "Harestua",
    labelDirection: "left",
    active: false,
    companies: [
      {
        name: "Granberg & Nordengen",
        logo: "https://cdn.rubics.as/granberg-og-nordengen/675573b62778fc9bf4bc9bf4/h_100/temp-logo-gnas.jpg",
        phone: "916 40 089",
        email: "firmapost@gnas.no",
        website: "gnas.no/",
      },
    ],
  },
  {
    id: "20",
    label: "Ålesund",
    labelDirection: "right",
    active: false,
    companies: [
      {
        name: "Storm Elektro Vest",
        logo: "https://cdn.rubics.as/storm-elektro-vest/681c6c379f00088f1b2fa48d/h_100/storm-elektro-vest-logo.png",
        phone: "406 03 200",
        email: "post@stormelektro.com",
        website: "www.stormelektro-vest.no",
      },
    ],
  },
  {
    id: "21",
    label: "Sandnessjøen",
    labelDirection: "right",
    active: false,
    companies: [
      {
        name: "Sinus Sandnessjøen",
        logo: "https://cdn.rubics.as/elteragruppen/69662249139749ea375ca354/logo-sinus-sandnessjoen.png",
        phone: "02473",
        email: "post@sinus247.no",
        website: "www.sinus247.no/sinus-sandnessjoen",
      },
    ],
  },
  {
    id: "22",
    label: "Mosjøen",
    labelDirection: "right",
    active: false,
    companies: [
      {
        name: "Sinus Mosjøen",
        logo: "https://cdn.rubics.as/elteragruppen/69662326139749ea375caac8/logo-sinus-mosjoen.png",
        phone: "02473",
        email: "mosjoen@sinus247.no",
        website: "www.sinus247.no/sinus-mosjoen",
      },
    ],
  },
  {
    id: "23",
    label: "Brønnøysund",
    labelDirection: "right",
    active: false,
    companies: [
      {
        name: "Sinus Brønnøysund",
        logo: "https://cdn.rubics.as/elteragruppen/696623e9139749ea375cb27d/logo-sinus-bronnoysund.png",
        phone: "750 08 000",
        email: "bronnoysund@sinus247.no",
        website: "www.sinus247.no/sinus-bronnoysund",
      },
    ],
  },
  {
    id: "24",
    label: "Nesna",
    labelDirection: "right",
    active: false,
    companies: [
      {
        name: "Sinus Nesna",
        logo: "https://cdn.rubics.as/elteragruppen/696622a7139749ea375ca672/logo-sinus-nesna.png",
        phone: "02473",
        email: "nesna@sinus247.no",
        website: "www.sinus247.no/sinus-nesna",
      },
    ],
  },
  {
    id: "25",
    label: "Bodø",
    labelDirection: "right",
    active: false,
    companies: [
      {
        name: "Sinus Bodø",
        logo: "https://cdn.rubics.as/elteragruppen/696622f1139749ea375ca8dc/logo-sinus-bodo.png",
        phone: "755 90 090",
        email: "firmapost.bodo@sinus247.no",
        website: "www.sinus247.no/sinus-bodo",
      },
    ],
  },
  {
    id: "26",
    label: "Odda",
    labelDirection: "right",
    active: false,
    companies: [
      {
        name: "BMI Installasjon",
        logo: "https://cdn.rubics.as/elteragruppen/696624c7139749ea375cbb8d/eltera-bedrift-bmi-installasjon.png.webp",
        phone: "536 50 000",
        email: "firmapost@bmi.no",
        website: "bmi.no",
      },
    ],
  },
  {
    id: "27",
    label: "Sandane",
    labelDirection: "right",
    active: false,
    companies: [
      {
        name: "Henden Elektro",
        logo: "https://cdn.rubics.as/elteragruppen/69662981139749ea375d07ad/logo-henden.png",
        phone: "578 84 610",
        email: "post@hendenelektro.no",
        website: "www.hendenelektro.no",
      },
    ],
  },
  {
    id: "28",
    label: "Hjartdal",
    labelDirection: "left",
    active: false,
    companies: [
      {
        name: "Elektrotech",
        logo: "https://cdn.rubics.as/elteragruppen/69662be0139749ea375d30b9/logo-elektrotech.png",
        phone: "350 23 770",
        email: "post@elektrotech.no",
        website: "www.elektrotech.no",
      },
    ],
  },
  {
    id: "29",
    label: "Stathelle",
    labelDirection: "left",
    active: false,
    companies: [
      {
        name: "BK Installasjon",
        logo: "https://cdn.rubics.as/elteragruppen/69c652abc91ea0a4ebdead3d/bk-logo.jpg",
        phone: "400 76 888",
        email: "cha@bkinstallasjon.no",
        website: "bkinstallasjon.no",
      },
    ],
  },
  {
    id: "30",
    label: "Mandal",
    labelDirection: "right",
    active: false,
    companies: [
      {
        name: "Sørlandets Elektro",
        logo: "https://cdn.rubics.as/elteragruppen/69c652abc91ea0a4ebdeadb2/sorlandets-logo.jpg",
        phone: "900 61 330",
        email: "rune@seeas.no",
        website: "",
      },
    ],
  },
];
